/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/feedback.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { toast } from "react-hot-toast";

const log: any = LoggerModule?.getInstance();

export interface IFeedbackFormMethods extends IPluginMethodMap {
  feedbackForm(args: FeedbackFormProps): Promise<any>;
}

export interface IFeedbackProps {
  anniversaryDate?: string;
  batchNo?: string;
  comments?: string;
  dateOfBirth?: string;
  email?: string;
  gtin?: string;
  phone?: string;
  rating?: number;
  userName?: string;
  appMode?: string;
}
export interface FeedbackFormProps {
  apiURL: string;
  payload: IFeedbackProps;
}

export class FeedbackFormService implements IAgentPlugin {
  readonly methods?: IFeedbackFormMethods;

  constructor() {
    this.methods = {
      feedbackForm: this.feedbackForm.bind(this),
    };
  }

  async feedbackForm(args: FeedbackFormProps) {
    console.log(`args in feedbackForm service :`, args);

    try {
      const res = await axios.post(
        `${args.apiURL}${config?.feedbackFormEP}`,
        {
          ...args?.payload,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (res?.data) {
        console.log(` On Success of getting provenance data:`, res?.data);
        let _data = res?.data;
        return _data;
      }
    } catch (err: any) {
      // return err;
      toast.error(
        `${
          err?.response?.data?.error?.error_message ??
          err?.response?.data?.error_message ??
          "Could not able get provenance"
        }`,
        {
          duration: 3000,
        }
      );
    }
  }
}
